import { connect } from 'react-redux'
import RatesModal from './RatesModal'

const stateToProps = () => ({})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(RatesModal)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/PricingTable/RatesModal/RatesModal.container.js